import Vue from 'formVueLp001';

new Vue({
  el: '.l-wrapper'
});
